// extracted by mini-css-extract-plugin
module.exports = {"chat-finished__greeting":"chat-finished__greeting__UC7RI","chat-finished__message":"chat-finished__message__7eRP9"};